
import mercury from "./assets/mercury.png";
import venus from "./assets/venus.jpg";
import earth from "./assets/earth.jpg";
import mars from "./assets/mars.jpg";
import jupiter from "./assets/jupiter.jpg";
import saturn from "./assets/saturn.jpg";
import uranus from "./assets/uranus.jpg";
import neptune from "./assets/neptune.jpg";

const my_images = {
    'mercury': mercury,
    'venus': venus,
    'earth': earth,
    'mars' : mars,
    'jupiter': jupiter,
    'saturn': saturn,
    'uranus': uranus,
    'neptune': neptune
};

export default my_images;